import React from "react";
import SchooglinkSmartSchool from "../assets/SchooglinkSmartSchool.png";

const LC2 = () => {
  return (
    <section className="w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 mt-24">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
        {/* Image Section */}
        <div className="flex-1 flex justify-center lg:justify-start">
          <img
            src={SchooglinkSmartSchool}
            alt="Schooglink Smart School"
            className="w-full max-w-sm sm:max-w-md lg:max-w-xl h-auto object-contain"
          />
        </div>

        {/* Text Section */}
        <div className="flex-1 flex flex-col justify-center items-center lg:items-start text-center lg:text-left">
          <div className="lg:ml-auto max-w-2xl">
            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-bold">
              Schooglink Smart School
            </h1>
            <p className="text-md sm:text-base md:text-lg lg:text-xl font-semibold mt-4 text-[#161DD9]">
              NEP 2020 compliant smart classrooms with 360° feedback loop
            </p>
            <p className="text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl mt-4 font-semibold text-gray-700 leading-relaxed">
              A unique tech platform developed in-house that delivers, monitors,
              and analyzes every function of the smart hybrid classroom designed
              &amp; set up by Schooglink, tracking learning outcomes, identifying
              and bridging learning gaps. A platform designed for scale.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mt-6 justify-center lg:justify-start w-full">
              <a href="contactus" className="w-full sm:w-auto">
                <button className="bg-[#4DAF3A] text-white py-2 px-6 h-12 w-full sm:w-auto rounded-lg text-sm sm:text-base font-semibold hover:bg-green-600 transition duration-300">
                  Get Started
                </button>
              </a>
              <a href="smart" className="w-full sm:w-auto">
                <button className="bg-[#203D78] text-white py-2 px-6 h-12 w-full sm:w-auto rounded-lg text-sm sm:text-base font-semibold hover:bg-blue-900 transition duration-300">
                  Explore
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LC2;
